module.exports = __webpack_public_path__ + "media/icons/star-2-bf5d79b1.svg";